<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="flex w-full bg-img vx-row no-gutter justify-center items-center">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-2/5 m-4">
      <vx-card>

        <div class="vx-card__title mb-6">
          <h2 class="text-center text-primary">{{activeSpaceInfo.title}}</h2>
          <h2 class="text-center">클래스에 팀원을 초대합니다.</h2>
        </div>

        <img src="@/assets/images/pages/graphic-1.png" alt="inviteimg" class="mx-auto mb-2" width="250px" height="220px">

        <div class="count-down text-center">
          <div>
            <p> 초대할 팀원의 Email을 입력해보세요 </p> <br>
            <vs-textarea placeholder="예) user01@filledyou.com; user02@google.com" v-model="emails"/>
          </vs-textarea>
          </div>
        </div>
        <!-- <vs-divider position="center">Subscribe</vs-divider> -->
        <div class="subscription w-1/2">
          <!-- <vs-input type="email" label-placeholder="Email" v-model="value1" class="w-full mb-4" /> -->

        </div>
        <vs-button class="w-1/2" color="primary" type="flat" @click="skip()">Skip</vs-button>
        <vs-button class="w-1/2" color="primary" type="filled" @click="done()">완료</vs-button> &nbsp;
        <!-- <vs-button class="w-1/2" color="primary" type="flat" @click="skip()">Skip</vs-button> &nbsp; -->
        <span>문의사항:mesen@filledyou.com</span>
      </vx-card>
    </div>
  </div>
</template>


<script>

export default {
  data() {
    return {
      emails: ''
    }
  },
  computed: {
    activeSpaceInfo() {
      return this.$store.state.space.ActiveSpaceInfo
    }
  },
  methods: {
    skip() {
      this.$router.push("/apps/space").catch(() => {})
    },
    done() {
      this.$vs.loading()
      const payload = {
        id: this.activeSpaceInfo.id,
        title: this.activeSpaceInfo.title,
        emails: this.emails
      }
      this.$store.dispatch('space/inviteWorkspace', payload)
      .then(() => {
        this.$vs.loading.close()
        this.$vs.notify({
          color: 'success',
          title: '초대 완료',
          text: '입력하신 이메일로 초대장을 전송하였습니다.'
        })
        this.$router.push("/apps/space").catch(() => {})
      })
      .catch(() => {
        this.$vs.loading.close()
        this.$vs.notify({
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          title: '초대 실패',
          text: '관리자에게 문의 부탁 드립니다.'
        })
        this.$router.push("/apps/space").catch(() => {})
      })

    }
  }
}

</script>
